<template>
    <div class="card">
                            <h4 class="card-title text-uppercase flexbox justify-content-between">
                                <strong>ADD TEST FOR {{training_title}}</strong>
                                <button class="btn btn-xs btn-bold btn-primary" @click="addTestModal()" type="button">Add Test</button>
                            </h4>
                            <div class="card-body">
                                <div class="error" v-if="question_error">
                                        *You have to add at least one question.
                                    </div>
                                <!-- <input type="file" accept=".xls,.xlsx"  ref="test" class="mb-10 form-control" @change="docSelected" placeholder="Choose..."/> -->
                                <div class="row">
                                    <div class="col-md-7">
                                        <div class="form-group">
                                            <label for="question">Question</label>
                                            <input class="form-control" type="text" id="question" v-model="question"/>
                                        </div>
                                        <div class="form-group">
                                            <label for="answer">Correct Option</label>
                                            <input class="form-control" type="text" id="answer" v-model="correct_answer"/>
                                        </div>
                                        <div class="form-group">
                                            <label for="option1">Other Option</label>
                                            <input class="form-control" type="text" id="option1" v-model="option1"/>
                                        </div>
                                        <div class="form-group">
                                            <label for="option2">Other Option</label>
                                            <input class="form-control" type="text" id="option2" v-model="option2"/>
                                        </div>
                                        <button :disabled="question==''" class="mb-10 btn btn-sm btn-bold btn-primary" @click="addQuestion" type="button">Add</button>        
                                    </div>
                                    <div class="col-md-5">
                                        <h6 class="mb-12 fw-600">List of added questions</h6>
                                        <div v-if="isQuestion" class="p-10 b-1 border-secondary">
                                            <div  class="mb-10 flex justify-content-between" v-for="(question, i) in questions_list" :key="i">
                                                <p>
                                                {{i+1}}). {{question}}
                                                </p>
                                            </div>
                                        </div>
                                        <div v-else class="b-1 border-secondary text-center">No Questions Yet</div>
                                    </div>
                                </div>
                            </div>
                         
                         <!-- Modal for delete -->
            <modal name="add-action" height="auto" class="modal-container" :clickToClose="false">
                <div class="modal-content">
                    <div class="callout callout-error py-10 px-0 mb-0" role="alert">
                        <span class="close mr-10" @click="hideModal($modal)" aria-label="Close" data-dismiss="close"><i class="ion-close-round"></i></span>
                        <h5 class="text-capitalize">Are you sure you want to add this test?</h5>
                        <div class="p-10">
                            <p>Tests for trainings cannot be edited/deleted. Please confirm all questions and answers before proceeding.</p>
                            <button class="btn btn-bold btn-sm btn-danger" disabled v-if="loadTest">
                                <circle-spin class="m-0"></circle-spin>
                            </button>
                            <button class="btn btn-bold btn-sm btn-danger" v-else type="button" @click="addTest">Add</button>
                        </div>
                    </div>
                </div> 
            </modal> 
                        </div>
                        
</template>

<script>
import axios from "axios";
import {
  required
} from "vuelidate/lib/validators";

export default {
    props: ['training_title', 'training_id'],
    data() {
        return {
            loadTest: false,
            isQuestion: false,
            question: "",
            option1: "",
            option2: "",
            correct_answer: '',
            invalid_answers:[],
            question_error: false,
            questions_list: [],
            correct_list: [],
            invalid_list: [],
            all_questions: [],
            test_id: null
        }
    },
    methods: {
        addQuestion() {
            this.question_error = false
            this.invalid_answers.push(this.option1, this.option2)
            this.questions_list.push(this.question)
            this.correct_list.push(this.correct_answer)
            this.invalid_list.push(this.invalid_answers)

            this.isQuestion = true
            this.question = ""
            this.correct_answer = ""
            this.option1 = ""
            this.option2 = ""
            this.invalid_answers = []
        },
        addTestModal() {
            if(this.questions_list.length < 1){
                this.question_error = true
            }
            else{
                this.question_error = false
                this.$modal.show("add-action");
            }
        },
        hideModal(a) {
            a.hide('add-action')
        },
        
        async sendQuestions() {
            for(const userData of this.all_questions) {
            //    console.log('here')
                        try {
                            const res = await axios.post("/admin/add?type=question", userData)
                        }
                        catch(err) {
                            this.$notify({
                                    group: 'response',
                                    type: 'error',
                                    title: `${err.response.data.message}`,
                                    duration: 5000
                                });
                        }
                    }
                    // console.log('gets here')
                    this.loadTest = false
                    this.$notify({
                        group: 'response',
                                    type: 'success',
                                    title: 'Test added successfully',
                                    duration: 2500
                    });
                    setTimeout(() => {
                        location.reload()
                    }, 3000)
        },
        addTest() {
                this.loadTest = true
                let userData = {
                    trainingId: this.training_id,
                    title: this.training_title
                }
                // Add Test request first
                axios.post('/admin/add?type=test', userData)
                .then(res => {
                    this.test_id = res.data.data.id
                    // Arrange the questions and their answers into proper format
                    for(let i=0; i < this.questions_list.length; i++) {
                        this.all_questions.push({
                            testId: this.test_id,
                            question: this.questions_list[i],
                            correct_answer: this.correct_list[i],
                            invalid_answers: this.invalid_list[i],
                        })
                    }
                    this.sendQuestions()
                })
                .catch(err=> {
                    this.loadTest = false
                    this.$notify({
                        group: 'response',
                        type: 'error',
                        title: `${err.response.data.message}`,
                        duration: 5000
                    });
                })            
        } 
    }
}
</script>